module.exports = __webpack_public_path__ + "static/media/p15.b3ceae5c.jpeg";